export const prefix = '[Programs][Class][Details]';
